module.exports = require('core/components/menu');
module.exports.mobileMenuToggle = function () {
  $('[data-toggle=d-none]').click(function () {
    $($(this).data('target')).toggleClass('d-none');
  });
};